const DEFAULT_CARD_TYPE = 'Visa';
const regexToCardsMaping = {
    Bijcard: /^5100081/, // CLARIFY: full length of card ?
    Jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    Cup: /^(62[0-9]{14,17})$/,
    Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    Maestro: /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/,
    Master: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    Amex: /^3[47][0-9]{13}$/,
    Diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    // eslint-disable-next-line max-len
    Discover: /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
    Cartebancaire: /^(4|5|6)\d{15}/
};

/**
 * @description PaymentForm implementation
 * @param {AjaxForm} AjaxForm Base widget for extending
 * @returns {typeof PaymentForm}
 */
export default function (AjaxForm) {
    return class PaymentForm extends AjaxForm {
        prefs() {
            return {
                cardNumberField: 'dwfrm_creditCard_cardNumber',
                cardTypeField: 'dwfrm_creditCard_cardType',
                ...super.prefs()
            };
        }

        init() {
            super.init();
            this.eventBus().on('process.card.number', 'processCardNumber');

            /* To hide state drop down ifcountry is not us */
            $('#dwfrm_creditCard_addressFields_country').on('change', function() {
                // @ts-ignore
                if(this.value !== 'US') {
                    $('.states').hide();
                } else {
                    $('.states').show();
                }
            });
        }

        /**
         * @description Get Form fields and extend them with cardType
         * @returns {object} Object contains form fields
         */
        getFormFields() {
            const formFields = super.getFormFields();

            const {
                cardNumberField,
                cardTypeField
            } = this.prefs();
            const cardType = this.determinCardType(
                formFields[cardNumberField]
            ).shift() || DEFAULT_CARD_TYPE;

            formFields[cardTypeField] = cardType;

            return formFields;
        }

        /**
         * @description Determin card type by card number
         * @param {string} cardNumber number of card
         * @returns {Array<string>} result
         */
        determinCardType(cardNumber) {
            const cardNumberReplaced = cardNumber.replace(/[\s-]/g, '');

            return Object.keys(regexToCardsMaping)
                .filter(key => regexToCardsMaping[key] && regexToCardsMaping[key].test(cardNumberReplaced));
        }

        /**
         * Determins type of credit card and emit event to update validation rules of CVV field
         * @param {string} cardNumber
         */
        processCardNumber(cardNumber) {
            const cardType = this.determinCardType(cardNumber).shift();

            this.eventBus().emit('update.cvv.validation', cardType);
        }
    };
}
